<template>
    <div class="bt-header">
        <div class="row" style="background-color: #ebebeb">
            <div class="col-sm-12">
                <div>
                    <div class="bt-navbar-content" style="height:150px;">
                        <div class="pull-right">
                            <a class="instagram fa fa-instagram fa-2x" href="https://www.instagram.com/brabanttools/" target="_blank"></a>
                        </div>
                        <div class="pull-right" style="margin-right: 10px">
                            <a class="facebook fa fa-facebook-square fa-2x" href="https://www.facebook.com/Brabant-Tools-403458056446088/timeline/" target="_blank"></a>
                        </div>
                        <div class="pull-right" style="margin-right: 10px">
                            <a class="linked-in fa fa-linkedin-square fa-2x" href="https://www.linkedin.com/in/walter-willems-7a411025/" target="_blank"></a>
                        </div>
                        <div class="col-sm-3" style="margin-top: 10px;">
                            <a href="/">
                                <img class="logo" height="134" src="../assets/logo.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <carousel class="carousel hidden-xs" :perPage="4" :autoplay="true" :autoplayHoverPause="false" :autoplayTimeout="1500" :loop="true" :paginationEnabled="false" :size="0">
                                <slide v-for="brand in this.brands" :key="brand.imageLocation">
                                    <span class="helper"></span><img class="carousel-image" :src="BACKEND_BASE_URL + '/images/' + brand.imageLocation">
                                </slide>
                            </carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="background-color: #ebebeb">
            <div class="col-sm-12">
                <div>
                    <div class="col-sm-12 bt-navbar-languages">
                        <div class="pull-left">
                            <div>
                                <span class="language" v-bind:class="{'opacitated': getLocale() === 'fr'}" @click="changeLocale('nl')">
                                    <img height="11px" src="../assets/flags/4x3/nl.svg" />
                                    <span style="font-size: 10px;"> NL</span>
                                </span>
                                <span style="border-right:1px solid;">&nbsp;</span>
                                <span class="language" v-bind:class="{'opacitated': getLocale() === 'nl'}" @click="changeLocale('fr')">
                                    <img height="11px" src="../assets/flags/4x3/fr.svg" />
                                    <span style="font-size: 10px;"> FR</span>
                                </span>
                            </div>
                        </div>
                        <div class="pull-right" style="cursor: pointer" @click="goto_shoppingcart()">
                            <i class="glyphicon glyphicon-shopping-cart"></i> {{$t("shoppingcart")}} <span class="badge">{{totalAmountOfProductsInShoppingCart}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 bt-navbar">
                <div>
                    <div>
                        <span class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'home'}" @click="goto_home()">
                            {{$t('home')}}
                        </span>
                        <span class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'merken'}"
                              @click="goto_brands()">
                            {{$t('brands')}}
                        </span>
                        <span class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'aanbiedingen'}"
                              @click="goto_actions()">
                            {{$t('actions')}}
                        </span>
                        <span v-if="(loggedInCustomer.email && loggedInCustomer.email.split('@')[1] !== 'nilfisk.com' && loggedInCustomer.email.split('@')[1] !== 'gesco.be') || !loggedInCustomer.id" class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'producten'}"
                              @click="goto_products()">
                            {{$t('products')}}
                        </span>
                        <span v-if="_self.$can('btonly')" class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'klanten'}"
                              @click="goto_customers()">
                            {{$t('customers')}}
                        </span>
                        <span v-if="loggedInCustomer.id" class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'mijnOrders'}"
                              @click="goto_myorders()">
                            {{$t('my_orders')}}
                        </span>
                        <span class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'contact'}"
                              @click="goto_contact()">
                            {{$t('contact')}}
                        </span>
                        <span v-if="!loggedInCustomer.id" class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'klantWorden'}"
                              @click="goto_become_customer()">
                            {{$t('become_customer')}}
                        </span>
                        <span class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'privacy'}"
                              @click="goto_privacy()">
                            {{$t('privacy')}}
                        </span>
                        <span v-if="_self.$can('btonly')" class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'prijzenAanpassen'}"
                              @click="goto_change_prices()">
                            {{$t('change_prices')}}
                        </span>
                        <span v-if="_self.$can('btonly')" class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'productenImporteren'}"
                              @click="goto_import_products()">
                            {{$t('import_products')}}
                        </span>
                        <span class="bt-navbar-item" v-bind:class="{'bt-navbar-item-active': active === 'vacatures'}"
                              @click="goto_vacatures()">
                            {{$t('vacatures')}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel'
    import { mapGetters } from 'vuex'
    import * as types from '../store/mutation-types'

    export default {
        components: { Carousel, Slide },
        props: ['active'],
        name: 'BtHeader',
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL
            }
        },
        created() {
            this.$store.dispatch('getBrands')
        },
        methods: {
            changeLocale(locale) {
                this.$i18n.locale = locale
                localStorage.setItem('language', locale)
            },
            getLocale() {
                return this.$i18n.locale
            },
            goto_home() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'home')
                const path = '/';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_brands() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'merken')
                const path = '/merken';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_actions() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'aanbiedingen')
                const path = '/aanbiedingen';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_products() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'producten')
                const path = '/producten';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_customers() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'klanten')
                const path = '/klanten';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_myorders() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'mijnOrders')
                const path = '/mijnorders';
                if (this.$route.path !== path) this.$router.push(path).catch(() => { })
            },
            goto_become_customer() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'klantWorden')
                const path = '/klantworden';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_contact() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'contact')
                const path = '/contact';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_shoppingcart() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'winkelwagen')
                const path = '/winkelwagen';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_privacy() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'privacy')
                const path = '/privacy';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_change_prices() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'prijzenAanpassen')
                const path = '/prijzen';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_import_products() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'productenImporteren')
                const path = '/productenimporteren';
                if (this.$route.path !== path) this.$router.push(path)
            },
            goto_vacatures() {
                this.$store.commit(types.SET_ACTIVE_SCREEN, 'vacatures')
                const path = '/vacatures';
                if (this.$route.path !== path) this.$router.push(path)
            }
        },
        computed: {
            ...mapGetters({
                brands: 'brands',
                productsInShoppingCart: 'productsInShoppingCart',
                loggedInCustomer: 'loggedInCustomer'
            }),
            totalAmountOfProductsInShoppingCart() {
                let productsQuantity = 0
                if (this.productsInShoppingCart) {
                    this.productsInShoppingCart.forEach((product) => {
                        productsQuantity += parseInt(product.amount)
                    })
                }
                return Math.abs(productsQuantity)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .carousel {
        margin-top: 20px;
        height: 50px;
    }

    .carousel-image {
        vertical-align: middle;
        margin-right: 10px;
        max-height: 50px;
    }

    .helper {
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }
</style>
